import ReservationHistories                     from "../../../../domain/reservation/history/ReservationHistories";
import ReservationHistoryRepository
                                                from "../../../../domain/reservation/history/ReservationHistoryRepository";
import ReservationId                            from "../../../../domain/reservation/ReservationId";
import { apiPutAcceptReservationCancelRequest } from "../../../api/reservation/cancel";
import { apiGetReservationCancelRequests }      from "../../../api/reservation/history";

class ReservationHistoryDataSource implements ReservationHistoryRepository {
  async findByCancelRequested(): Promise<ReservationHistories> {
    return apiGetReservationCancelRequests();
  }

  async acceptCancelRequest(reservationId: ReservationId): Promise<void> {
    return apiPutAcceptReservationCancelRequest(reservationId);
  }
}

export default ReservationHistoryDataSource;
